import React, { Component } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { PaddedSection, PaginationButton, SlidePagination } from '../../atoms';

import './styles.css';

/**
 * A template for the quotes section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object[]} quotes
 * @prop {String} heading
 *
 * @augments {Component<Props>}
 */
export default class QuotesSection extends Component {

	state = {
		index: 0,
	};

	genSwipeableViews = ({ index, quotes }) => (
		// @ts-ignore
		<SwipeableViews
			enableMouseEvents
			index={index}
			onChangeIndex={this.handleChangeIndex}
			resistance
		>
			{quotes.map(this.mapQuotes)}
		</SwipeableViews>
	);

	mapQuotes = ({ quote, author }, index) => {
		return (
			<blockquote key={index} className='QuotesSection-quote'>
				<span>{quote}</span>
				<footer><cite>{author}</cite></footer>
			</blockquote>
		);
	};

	handleChangeIndex = (index) => this.setState({ index });

	handleRightClick = () => {
		this.setState(({ index }) => {
			if (index === this.props.quotes.length - 1) return { index: 0 };
			return { index: ++index };
		});
	}

	handleLeftClick = () => {
		this.setState(({ index }) => {
			if (index === 0) return { index: this.props.quotes.length - 1 };
			return { index: --index };
		});
	}

	render () {
		const index = this.state.index;
		const quotes = this.props.quotes;
		const heading = this.props.heading;

		return (
			<PaddedSection className='QuotesSection'>
				<h1>{heading}</h1>
				<SlidePagination
					count={quotes.length}
					index={index}
					onChange={this.handleChangeIndex}
				/>
				{this.genSwipeableViews({ index, quotes })}
				<PaginationButton
					className='QuotesSection-button-left'
					onClick={this.handleLeftClick}
				/>
				<PaginationButton
					className='QuotesSection-button-right'
					onClick={this.handleRightClick}
					right
				/>
			</PaddedSection>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/templates/QuotesSection/QuotesSection.js